// extracted by mini-css-extract-plugin
module.exports = {"header":"_84766037","links":"_b626a73b","link":"_3868f2a8"};